import api from './api';

/** "Xuất danh sách xác nhận hoạt động đã tham gia" — trong chức năng Điểm rèn luyện. */
const xacNhanRenLuyenService = {
  // Đoàn trường: tạo cho toàn bộ sinh viên đã tham gia trong 1 học kỳ — có thể mất vài phút với
  // học kỳ nhiều sinh viên (mỗi SV render + ký 1 file PDF riêng), nên dùng timeout dài hơn mức
  // mặc định 30s của axios để tránh báo lỗi/timeout trên UI trong khi backend vẫn đang xử lý đúng.
  tao: async (body) => {
    const res = await api.post('/api/diem-ren-luyen/xac-nhan/tao', body, { timeout: 15 * 60 * 1000 });
    return res.data.data;
  },

  // Đoàn trường: xem theo học kỳ (đối soát)
  theoHocKy: async (soHocKy, maNamHoc) => {
    const res = await api.get('/api/diem-ren-luyen/xac-nhan', { params: { soHocKy, maNamHoc } });
    return res.data.data;
  },

  // Sinh viên: danh sách của chính mình
  cuaToi: async () => {
    const res = await api.get('/api/diem-ren-luyen/xac-nhan/cua-toi');
    return res.data.data;
  },

  // Tải file PDF (blob) — dùng cho cả admin và sinh viên, quyền kiểm ở backend
  taiFile: async (id) => {
    const res = await api.get(`/api/diem-ren-luyen/xac-nhan/${id}/file`, { responseType: 'blob' });
    return res.data;
  },
};

export default xacNhanRenLuyenService;
